export const SET_COUNTRY = 'SET_COUNTRY'
export const GET_COUNTRIES = 'GET_COUNTRIES'
export const GET_GLOBAL_SUMMARY = 'GET_GLOBAL_SUMMARY'
export const GET_COUNTRY_INFO = 'GET_COUNTRY_INFO'
export const GET_TOP_COUNTRIES = 'GET_TOP_COUNTRIES'
export const SET_LOADING = 'SET_LOADING'
export const SET_LOADING_TOP_COUNTRIES = 'SET_LOADING_TOP_COUNTRIES'